import React from 'react';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {FIELDDEFDISPLAYTYPE} from 'core/form/form';
import {createForm} from 'core/form/createForm';
import {lovValue, FormProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {Validate} from 'core/form/validate';
import {NumberFormat, Min, Max, HasLength, IsNumber} from 'core/form/rules';
import {optionsSearch} from "core/common/service/commonDataService";
import {Invoice} from "invoice/domain/invoiceDomain";
import {action} from "mobx";
import {observer} from "mobx-react";
import {PARTYROLE} from "party/partyDomain";
import commonService from "core/common/service/commonService";
import {GridRow} from "core/grid/domain/grid";
import {classNames} from "core/common/utils/domUtils";
import {LovItem} from "../../core/metamodel/mdEntity";
import {ENTITY_NUMBER_GEN_ENTITY} from "../constants";
import securityService from "core/security/securityService";
import {RESTRICTION} from "core/security/securityDomain";
import CustomerForm from "invoice/component/customerForm";
import InvoiceForm from "invoice/component/invoiceForm";

interface InvoiceAdvancedFormState {
  optionsForNumberGen: LovItem[];
}

interface InvoiceFormProps extends FormProps<Invoice, Invoice> {
  recalculate: (rootObject: Invoice, modifiedRows: GridRow[], toDeleteRows: GridRow[], params?: { [key: string]: any }) => Promise<any>;
}


@createForm({
  formName: 'InvoiceAdvancedForm',
  fields: [{
    name: 'monetaryRounding',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'internalComment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'accountingMatchingId'
  }, {
    name: 'entityNumberGen'
  }, {
    name: 'accountingNumber'
  }, {
    name: 'internalOrder'
  }, {
    name: 'relatedInvoice'
  }, {
    name: 'accountingProfitCenter'
  }, {
    name: 'costCenter'
  }]
}, () => <noscript/>)
@observer
export default class InvoiceAdvancedForm extends React.Component<InvoiceFormProps, InvoiceAdvancedFormState> {

  state: InvoiceAdvancedFormState = {optionsForNumberGen: []};

  componentWillMount() {
    let {dataObject} = this.props;

    optionsSearch(ENTITY_NUMBER_GEN_ENTITY, dataObject.getInvoiceParamsForNumberGenSearch(), '*')
      .then(res => {
        this.setState({
          optionsForNumberGen: [{value: null, label: '---'}, ...res.options],
        })
      });
  }


  @action recalculate = (evt?: any) => {
    return this.props.recalculate(this.props.dataObject, null, null);
  };


  render() {

    let {dataObject, rootObject, entities, formName} = this.props;
    let {
     monetaryRounding, internalComment,
      accountingMatchingId, entityNumberGen, accountingNumber, internalOrder, relatedInvoice, accountingProfitCenter, costCenter
    } = dataObject.getFormFields(formName);


    return (
          <BlockComp>
            <div className="row">
              <div className="fx col-xs-4">
                <StyledSelect {...accountingProfitCenter.props} />
              </div>
              <div className="fx col-xs-4">
                <StyledSelect  {...costCenter.props} />
              </div>
              <div className="fx col-xs-4">
                <StyledSelect {...accountingNumber.props} />
              </div>
            </div>

            <div className="row">
              <div className="fx col-xs-4">
                <MdTextField {...accountingMatchingId.props} />
                <Validate field={accountingMatchingId} value={accountingMatchingId.props.value}/>
              </div>
              <div className="fx col-xs-4">
                <MdTextField {...internalOrder.props} />
              </div>
              <div className="fx col-xs-4">
                <MdTextField {...relatedInvoice.props} />
              </div>
            </div>

            <div className="row">
              <div className="fx col-xs-4">
                <NumberField {...monetaryRounding.props} />
                <Validate field={monetaryRounding} value={monetaryRounding.props.value}>
                  <NumberFormat precision={1} scale={0}/>
                  <Min min={0}/>
                  <Max max={6}/>
                </Validate>
              </div>
              <div className="fx col-xs-4">
                <StyledSelect  {...entityNumberGen.props}
                               options={this.state.optionsForNumberGen}
                               clearable={false} />
              </div>
            </div>

            <div className="row">
              <div className="fx col-xs-12">
                <MdTextField {...internalComment.props} multiLine={true} rows={1}/>
              </div>
            </div>

          </BlockComp>
    );
  }
}





// WEBPACK FOOTER //
// ./src/invoice/component/invoiceAdvancedForm.tsx